import PropTypes from 'prop-types';
import Search from 'Shared/components/search';
import Animation from 'Shared/components/animation';
import InlineSvg from 'Shared/components/inline-svg';
import styles from './header-search.css';


const HeaderSearch = ({
  show,
  hide,
}) => (
  <Animation show={show} animation="slide_down">
    <div className={styles.container}>
      <div className={styles.searchContainer}>
        <Search />
      </div>
      <button type="button" className={styles.closeContainer} onClick={hide}>
        <InlineSvg src="/close.svg" />
      </button>
    </div>
  </Animation>
);

HeaderSearch.propTypes = {
  show: PropTypes.bool.isRequired,
  hide: PropTypes.func,
};

export default HeaderSearch;
